export enum commonIcons {
    HOTEL = 'Apartment',
    ROOM = 'Hotel',
    MEAL_PLAN = 'RoomService',
    RATE_PLAN = 'SellOutlined',
    TAX = 'ReceiptLong',
    SUPPLEMENT = 'LibraryAdd',
    CALENDAR = 'CalendarMonthOutlined',
    LIST = 'TableChartOutlined',
    STOP_SALE = 'DoDisturb',
    ARROW_LEFT = 'KeyboardArrowLeft',
    ARROW_RIGHT = 'KeyboardArrowRight',
    ARROW_UP = 'KeyboardArrowUp',
    ARROW_DOWN = 'KeyboardArrowDown',
    AI = 'AutoAwesomeOutlined',
    ADD = 'Add',
    DELETE_BIN = 'Delete',
    DELETE_X = 'Clear',
    CLOSE = 'Close',
    VIEW = 'VisibilityOutlined',
    DOWNLOAD = 'FileDownloadOutlined',
    FULL_SCREEN = 'Fullscreen',
    EXIT_FULL_SCREEN = 'FullscreenExit',
    EDIT = 'Edit',
    NEW_WINDOW = 'OpenInNew',
}
